<template>
  <div>
    <h5
      :style="{
        marginBottom: '16px',
        fontWeight: 'bold',
      }"
    >
      Price Range
    </h5>

    <div @click="handleClick">
      <Slider
        name="slider"
        ref="slider"
        v-model="sliderRange"
        lazy
        :tooltip-formatter="formatTooltip"
        :min="0"
        :max="sliderMax"
        :dotOptions="dotOptions"
        @drag-end="handleDrag"
        @change="handleChange"
      />
    </div>
  </div>
</template>

<script>
import Slider from "vue-slider-component";
import { formatCurrency } from "@/helpers/formatCurrency";
import "@/assets/slider.scss";

export default {
  name: "PriceFilters",
  components: {
    Slider,
  },

  props: {
    sliderMax: {
      type: Number,
      default: 1,
    },
    values: {
      type: Array,
      default: () => [0, 1],
    },
  },

  emits: ["change", "drag"],

  model: {
    prop: "values",
    event: "change",
  },

  setup() {
    const dotOptions = {
      style: {
        backgroundColor: "white",
        boxShadow: "0px 1px 4px -1px rgba(0,0,0,0.35)",
        border: "1px solid #ddd",
        height: "17px",
        width: "17px",
        marginTop: "-2px",
      },
    };

    return {
      dotOptions,
    };
  },

  data() {
    return {
      sliderValue: [0, 1],
    };
  },

  methods: {
    handleChange() {
      this.$emit("change", {
        min_price: this.sliderValue[0],
        max_price: this.sliderValue[1],
      });
    },

    handleClick() {
      this.$emit("drag", {
        min_price: this.sliderValue[0],
        max_price: this.sliderValue[1],
      });
    },

    handleDrag() {
      this.$emit("drag", {
        min_price: this.sliderValue[0],
        max_price: this.sliderValue[1],
      });
    },

    formatTooltip(value) {
      return formatCurrency(value, false);
    },
  },

  computed: {
    sliderRange: {
      get() {
        return this.values;
      },
      set(newVal) {
        this.sliderValue = newVal;
        this.handleChange();
      },
    },
  },

  watch: {
    sliderMax(newVal) {
      this.$refs.slider.setValue([0, newVal]);
    },

    values(newVal) {
      this.sliderValue = newVal;
    },
  },
};
</script>
